import React,{useState} from 'react'
import VehicleMain from './OEM Vehicle/Main'
import BatteryMain from './OEM Battery/Main'
const TabStyle={
    backgroundColor: "#d7d7d7",
    borderTopLeftRadius: "2px",
    borderTopRightRadius: "2px",
    marginLeft: "2px",
    fontSize: "16px",
    color: "#000",
    fontWeight: "700",
    width: "150px",
    textAlign: "center",
    padding: "10px 7px",
    cursor:'pointer'
}

const ActiveTabStyle={
    ...TabStyle,
    backgroundColor:'#066f69',
    color:'#fff'
}

export default function Main() {
    const [tab,setTab]=useState("vehicle")

    const handleTab = (type)=>{
        setTab(type)
    }
  return (
    <>
        <div className="Tabs" style={{display:'flex',position:'fixed',top:'71px',right:'2px'}}>
            <div className="subTab" style={tab === "vehicle" ? ActiveTabStyle : TabStyle} onClick={()=>handleTab("vehicle")}>
                <h5 style={{margin:'0'}}>Vehice OEM</h5>
            </div>
            <div className="subTab" style={tab === "battery" ? ActiveTabStyle : TabStyle} onClick={()=>handleTab("battery")}>
                <h5 style={{margin:'0'}}>Battery OEM</h5>
            </div>
        </div>

        {
            tab === "vehicle" ?
            <VehicleMain />
            :''
        }
        {
            tab === "battery" ?
            <BatteryMain />
            :''
        }
    </>
  )
}
